import React  from 'react'
import {Space} from "antd";



const TabView = ({
    items=[
        'Pending',
        'Voting',
        'In Development',
        'Released'
    ],
    onChange,
    activeItem = 'Pending'
                 })=>{



    return(
        <Space size={30}>
            {
                items.map((item)=>{

                    return <div className={`pointer font-lg ${activeItem==item && 'bold primary'} `}
                    onClick={()=>{
                        (typeof onChange == 'function') && onChange(item)
                    }}
                    >
                        {item}
                    </div>
                })
            }
        </Space>
    )
}

export default TabView